// Staff-run stations and their countdown screen (ADR-0033; spec/04 §3, spec/05 §5, spec/13 §3).
//
// A station is **managed** — a PC running the station app: paired, leased, locked down, health-reported — or
// **staff-run**: a console, a sim, a VR set, a table, run from the console with the server owning its timer. The
// default follows the kind; `CreateStation.managed` overrides it.
//
// **Plain values only** — no Zod, no `createRoute` — so the eval-free `@clavian/contracts/constants` barrel can
// re-export them for the console and its public countdown page without pulling `@hono/zod-openapi`'s `new Function`
// into a browser bundle (the `script-src` rule `constants/index.ts` exists for).
/** The station kinds (`StationKind`) that are managed — paired to a station app — unless the station says otherwise. */
export const MANAGED_BY_DEFAULT_KINDS = ['pc'];
/** Whether a station of `kind` is managed (paired) when it is defined without saying: only a `pc` is. */
export function stationManagedByDefault(kind) {
    return MANAGED_BY_DEFAULT_KINDS.includes(kind);
}
/** The minutes before the funded end staff are alerted at on a staff-run station (`sessions.staffAlertMinutes`). */
export const DEFAULT_STAFF_ALERT_MINUTES = [10, 5];
/** How often the countdown screen re-reads its station when no realtime frame has asked it to, in seconds. */
export const STATION_DISPLAY_POLL_SECONDS = 15;
/** The display token's shape: 22 base64url characters (128 random bits). */
export const STATION_DISPLAY_TOKEN_PATTERN = /^[A-Za-z0-9_-]{22}$/;
/** Whether `value` has the shape of a display token. Shape only: whether it is live is the api's to say. */
export function isStationDisplayTokenShape(value) {
    return STATION_DISPLAY_TOKEN_PATTERN.test(value);
}
// -- Console sessions: booked blocks and controllers, one order at the end (ADR-0034) --
/** The block chips the start form and "Add time" offer, in minutes: 30 min, 1 h, 2 h, 5 h (then Custom and Open). */
export const CONSOLE_BLOCK_MINUTES = [30, 60, 120, 300];
/** The most controllers a staff-run session can have, whatever the station's capacity says. */
export const CONSOLE_MAX_CONTROLLERS = 16;
/**
 * The player id a **walk-in** staff-run session carries on the wire (ADR-0034): the nil TypeID, with `walkIn: true`
 * beside it. The session itself stores no player; the wire keeps a well-formed id so the `Session` DTO every client
 * (and the station's generated C#) reads keeps `playerId` required. Never a real player.
 */
export const WALK_IN_PLAYER_ID = 'pla_00000000000000000000000000';
//# sourceMappingURL=staff-run.js.map